import { Box } from "@mui/material";
import { MuiDoubleLabel } from "../../../../../../../../components";
import { useSiteCore } from "../../../../../../../../hooks/useSiteCore";
import { coachAssignmentSiteCoreKeys } from "../../../../../../../createProgram/components/createProgramTabs/tabs/participant/components/coachAssignment/SiteCoreKeys";
import { CoachAssignmentList } from "../../../../../../../createProgram/components/createProgramTabs/tabs/participant/components/coachAssignment/components/coachAssignmentList/coachAssignmentList";
import { ViewCoachAssignmentDetails } from "../../../../../../../createProgram/modelsAndSchemas/Models";
import { useGetLoggedInUserDetails } from "../../../../../../../../aAdminTabTeam2/hooksAndFunctions/customHooks/useGetLoggedInUserDetails";
import { getDateFormatByCountry } from "../../../../../../../../helpers/constants/countryDateFormat";
import { convertToUserFormat } from "../../../../../../../../helpers/utils";
import { EMPTY_VALUE_DASH } from "../../../../../../../../helpers/constants";

const { coachAssignment, coachAssignmentToBeAssignedDate } =
  coachAssignmentSiteCoreKeys;

interface ViewCoachAssignmentProps {
  coachAssignmentDetails?:ViewCoachAssignmentDetails
}

export const ViewCoachAssignment = ({ coachAssignmentDetails}:ViewCoachAssignmentProps) => {
  const { useFetchLabel } = useSiteCore();
  const getSiteCoreLabel = useFetchLabel(coachAssignment);

  const { loggedInUser } = useGetLoggedInUserDetails();
  const userCountryDateFormat = getDateFormatByCountry(
    loggedInUser?.countryCode ?? "",
  ) as string;

  const toBeAssignDate=coachAssignmentDetails?.toBeAssignedDate?convertToUserFormat(coachAssignmentDetails?.toBeAssignedDate, userCountryDateFormat):EMPTY_VALUE_DASH

  return (
    <>
      <Box className="coach-assignment-container">
        <MuiDoubleLabel
          label={getSiteCoreLabel(coachAssignmentToBeAssignedDate)}
          value={toBeAssignDate} 
          data-testid="coach-assignment-to-be-assigned-date"
        />
      </Box>
      <CoachAssignmentList data-testid="coach-assignment-list" isViewOnly coachAssignmentList={coachAssignmentDetails?.coachTypeAssignments??[]} dateFormat={userCountryDateFormat}/>
    </>
  );
};
